import React, { useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoIcon from '@mui/icons-material/Info';
import DoneIcon from '@mui/icons-material/Done';
import outerCircle from '../Assets/images/vector.png';
import wellnessCategoriesImg from '../Assets/images/wellness categories.png';
import { IconButton, Tooltip, Typography, List, ListItem, ClickAwayListener } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import vikritinext from '../Assets/images/vikritinext.png'
import WelcomeScreenanimation from '../Assets/animations/welcomscreenrotation.json';
import axios from 'axios';
import { toast, Zoom } from 'react-toastify';
import Lottie from 'lottie-react';
import { getUserDetails } from '../Auth/AuthUtil';
import { profileModel } from '../Axios/AxiosConfig';

function Wellness2() {

    const navigete = useNavigate()
    const location = useLocation()
    const userDetails = getUserDetails()

    const [openTooltipIndex, setOpenTooltipIndex] = useState(null);

    const handleTooltipOpen = (index) => {
        setOpenTooltipIndex(index);
    };

    const handleTooltipClose = () => {
        setOpenTooltipIndex(null);
    };

    const wellnessItems =
        [
            {
                "name": "Energy & Weight Issues",
                "description": "For those feeling tired, sluggish, or struggling with weight",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Energy+%26+Weight+Issues.png",
                "selected": false,
                "sub_categories": [
                    "Fatigue & Low Energy",
                    "Unexplained Weight Gain/Loss",
                    "Blood Sugar Imbalances (Pre-diabetes, Diabetes)",
                    "Thyroid Issues (Hypothyroidism, Hyperthyroidism)",
                    "Cravings & Emotional Eating",
                    "Water Retention & Swelling",
                    "Slow Digestion & Weak Metabolism (Agni Imbalance)"
                ]
            },
            {
                "name": "Gut & Digestive Wellness",
                "description": "For those with stomach discomfort, bloating, or irregular digestion",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Gut+%26+Digestive+Health.png",
                "selected": false,
                "sub_categories": [
                    "Gas, Bloating & Indigestion",
                    "Acid Reflux & Heartburn",
                    "Constipation or Diarrhea",
                    "Gut Microbiome Imbalance",
                    "Food Sensitivities & Intolerances",
                    "Irritable Bowel Syndrome (IBS) & Gut Sensitivity (gut sensitivity, Gut Irritation)",
                    "Liver Health & Detox Issues (Fatty Liver, Toxins Overload)"
                ]
            },
            {
                "name": "Stress, Sleep & Mental Wellness",
                "description": "For those struggling with stress, sleep, and emotional balance",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Stress%2C+Sleep+%26++Mental+Well-Being.png",
                "selected": false,
                "sub_categories": [
                    "Chronic Stress & Anxiety",
                    "Sleep Disorders (Insomnia, Poor Sleep Quality)",
                    "Brain Fog & Lack of Focus",
                    "Low Mood & Emotional Imbalances",
                    "Headaches & Migraines",
                    "Overthinking & Racing Thoughts",
                    "Dizziness & Lightheadedness"
                ]
            },
            {
                "name": "Hormonal, Men & Women's Wellness",
                "description": "For hormone-related issues, menstrual & reproductive health",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Hormonal%2C+Men+%26+Women%E2%80%99s++Wellness.png",
                "selected": false,
                "sub_categories": [
                    "PCOS & Irregular Periods",
                    "Menstrual Cramps & PMS",
                    "Menopause Symptoms (Hot Flashes, Mood Swings)",
                    "Thyroid Issues",
                    "Low Libido & Reproductive Health",
                    "Hormonal Acne & Skin Issues",
                    "Breast Tenderness & Fibrocystic Breasts"
                ]
            },
            {
                "name": "Joint & Muscle Wellness",
                "description": "For those with body aches, joint pain, or chronic inflammation",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Joint+%26+Muscle+Wellness.png",
                "selected": false,
                "sub_categories": [
                    "Joint Pain & Stiffness",
                    "Muscle Aches & Fatigue",
                    "Chronic Inflammation",
                    "Back, Neck & Shoulder Pain",
                    "Tingling & Numbness in Hands/Feet (Circulation & Nerve Issues)",
                    "Autoimmune-related symptoms"
                ]
            },
            {
                "name": "Skin and hair Wellness",
                "description": "For those dealing with frequent infections, allergies, skin or hair problems",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Skin+%26+Hair+Health.png",
                "selected": false,
                "sub_categories": [
                    "Seasonal & Food Allergies",
                    "Skin Conditions (Eczema, Psoriasis, Rashes)",
                    "Hair Fall & Premature Graying",
                    "Allergies & Skin Sensitivities",
                    "Frequent Colds, Cough, & Weak Immunity",
                    "Chronic Sinus Issues & Respiratory Issues",
                    "Dust Allergy"
                ]
            },

            {
                "name": "Respiratory & Immune Wellness",
                "description": "For those who frequently get sick, struggle with allergies or have breathing problems",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Respiratory+%26+Immune+Health.png",
                "selected": false,
                "sub_categories": [
                    "Common Cold (Runny Nose & Sneezing)",
                    "Asthma (Breathing Trouble & Wheezing)",
                    "Bronchitis (Persistent Cough & Mucus)",
                    "Sinusitis (Blocked Nose & Headache)",
                    "Pneumonia (Severe Cough & Chest Pain)",
                    "Allergies (Sneezing & Itchy Eyes)",
                ]
            }
        ]

    const [allWellnessCategories, setWellnessCategories] = useState(wellnessItems)

    const handleCardClick = (index) => {
        setWellnessCategories(prevCategories => {
            const selectedCount = prevCategories.filter(category => category.selected).length;
            const isSelected = prevCategories[index].selected;

            return prevCategories.map((category, i) => {
                if (i === index) {

                    if (isSelected) {
                        return { ...category, selected: false };
                    }

                    if (selectedCount >= 2) {
                        toast.info("You can select up to 2 categories", {
                            position: 'top-center',
                            limit: 1,
                            style: {
                                fontSize: '14px',
                                fontFamily: '"Poppins", sans-serif',
                                fontWeight: 500,
                                backgroundColor: '#FDFDFD',
                                color: '#3B362A'
                            },
                            transition: Zoom,
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            closeButton: false,
                            theme: 'dark',
                        });
                        return category; // Do not change selection
                    }

                    return { ...category, selected: true };
                }

                return category;
            });

        });
    };



    const SubmitWellnessInterest = async () => {
        try {
            let res = await profileModel.post('/AddwellnessCategories', {
                UID: userDetails?.UID,
                Categories: allWellnessCategories.map((category) => {
                    return {
                        name: category.name,
                        imageUrl: category.imageUrl,
                        selected: category.selected
                    }
                })
            })

            if (res.status === 200) {
                navigete('/symptoms', { state: { from: location?.state?.from } })
            }
        }
        catch (err) {
            console.log(err.response.data)
        }
    }

    // const handleCardClick = (index) => {
    //     setWellnessCategories(prevCategories =>
    //         prevCategories.map((category, i) =>
    //             i === index
    //                 ? { ...category, selected: !category.selected }
    //                 : category
    //         )
    //     );
    // };

    return (
        <div className='Welcome-page-section'>
            <div className='Wellness-categories-section'>

                <div className="Welcome-section-animation">
                    <Lottie animationData={WelcomeScreenanimation} />
                </div>

                <div className='Wellness-categories-header'>
                    <p style={{ textAlign: "center", fontWeight: "500" }}>What wellness you want to improve?<br />
                    </p>
                </div>

                {allWellnessCategories.filter(category => category.selected).length >= 1 &&
                    <div className='border rounded-lg transition-all duration-300 ease-in-out'
                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#f4f4f4", padding: "0.5rem", borderRadius: "0.5rem", marginBottom: "1rem" }}>
                        <p>Max <span style={{ fontWeight: "700" }}>2</span> Categories</p>
                    </div>}

                <div>
                    <div className='Wellness-categories-list'>
                        {allWellnessCategories?.map((category, index) => (
                            <div
                                key={index}
                                className={`WellnessCard flex h-full gap-5 w-full items-center p-2 border rounded-lg cursor-pointer bg-[#F4F4F4] hover:bg-[#EDEDED] transition-all duration-300 ease-in-out`}
                                style={category.selected ? { border: '2px solid #DA6E0B' } : {}}
                                onClick={() => handleCardClick(index)}
                            >
                                <div className={`WellnessImg`}>
                                    <img src={category?.imageUrl} alt={category?.name} />
                                </div>

                                <p>
                                    {category?.name}
                                </p>

                                <ClickAwayListener onClickAway={handleTooltipClose}>
                                    <Tooltip

                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500, fontSize: "12px" }}>{category.description} </Typography>
                                                {category.sub_categories && category.sub_categories.length > 0 && (
                                                    <List>
                                                        {category.sub_categories.map((subCategory, subIndex) => (
                                                            <ListItem key={subIndex} dense>
                                                                <Typography variant="body2" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400, fontSize: "10px" }}> {subCategory}</Typography>
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                )}
                                            </React.Fragment>
                                        }

                                        onClose={handleTooltipClose}
                                        open={openTooltipIndex === index}
                                        disableFocusListener
                                        disableHoverListener
                                        disableTouchListener
                                        slotProps={{
                                            popper: {
                                                disablePortal: true,
                                            },
                                        }}

                                    >
                                        <IconButton
                                            style={{ justifySelf: "flex-end", marginLeft: "auto" }}
                                            enterTouchDelay={300}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleTooltipOpen(index)
                                            }}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    </Tooltip>
                                </ClickAwayListener>

                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    {
                        allWellnessCategories.filter(category => category.selected).length >= 1 && <div onClick={() => {
                            SubmitWellnessInterest()
                        }} style={{ alignSelf: "center", justifySelf: "center", width: "3rem", cursor: "pointer" }} >
                            <img src={vikritinext}></img>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default Wellness2;
